import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback } from "react";
import styles from "./switch.module.scss";
const SwitchButton = ({ onChange, checked, disabled, fromTimeBase, }) => {
    const onStatusChange = useCallback((e) => {
        onChange(e);
    }, [onChange]);
    return (_jsxs("label", Object.assign({ className: `${styles.switch} ${fromTimeBase ? styles.timeBaseSwitch : ""} showQuoteSwitch` }, { children: [_jsx("input", { type: "checkbox", onChange: (event) => onStatusChange(event.target.checked), checked: checked, disabled: disabled }), _jsx("span", { className: `${styles.slider}` })] })));
};
export default SwitchButton;
